var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"id":`group-${_vm.id}`,"label":_vm.label,"label-for":`select-${_vm.id}`}},[(_vm.options)?_c('b-form-select',{attrs:{"id":`select-${_vm.id}`,"name":`select-${_vm.id}`,"value":_vm.value,"options":_vm.options},on:{"input":_vm.onInput,"change":_vm.onChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }